(function () {
  const ANIMATION_DELAY = 500;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function ensureInner(answer) {
    let inner = answer.querySelector('.we-faq__answer-inner');
    if (inner) return inner;

    inner = document.createElement('div');
    inner.className = 'we-faq__answer-inner';
    while (answer.firstChild) inner.appendChild(answer.firstChild);
    answer.appendChild(inner);
    return inner;
  }

  function setAnswerHeight(answer, height) {
    answer.style.height = typeof height === 'number' ? `${height}px` : height;
  }

  function getContentHeight(answer) {
    return ensureInner(answer).offsetHeight;
  }

  function openAnswer(answer, immediate) {
    if (immediate || prefersReducedMotion()) {
      setAnswerHeight(answer, 'auto');
      return;
    }

    setAnswerHeight(answer, getContentHeight(answer));
    window.setTimeout(() => setAnswerHeight(answer, 'auto'), ANIMATION_DELAY);
  }

  function closeAnswer(answer, immediate) {
    if (immediate || prefersReducedMotion()) {
      setAnswerHeight(answer, '');
      return;
    }

    const height = getContentHeight(answer);
    setAnswerHeight(answer, height);
    requestAnimationFrame(() => setAnswerHeight(answer, 0));
    window.setTimeout(() => setAnswerHeight(answer, ''), ANIMATION_DELAY);
  }

  function setItemOpen(item, isOpen, immediate) {
    const trigger = item.querySelector('[data-we-faq-trigger]');
    const answer = item.querySelector('.we-faq__answer');
    if (!trigger || !answer) return;

    ensureInner(answer);
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (isOpen) {
      item.classList.add('is-open');
      openAnswer(answer, immediate);
      return;
    }

    if (immediate || prefersReducedMotion()) {
      item.classList.remove('is-open');
      closeAnswer(answer, immediate);
      return;
    }

    closeAnswer(answer, false);
    item.classList.remove('is-open');
  }

  function initFaq(root) {
    let isTransitioning = false;

    root.querySelectorAll('[data-we-faq-item]').forEach((item) => {
      const answer = item.querySelector('.we-faq__answer');
      if (!answer) return;

      ensureInner(answer);

      if (item.classList.contains('is-open')) {
        setItemOpen(item, true, true);
      }
    });

    root.querySelectorAll('[data-we-faq-trigger]').forEach((trigger) => {
      if (trigger.dataset.weFaqBound) return;
      trigger.dataset.weFaqBound = 'true';

      trigger.addEventListener('click', () => {
        if (isTransitioning && !prefersReducedMotion()) return;

        const item = trigger.closest('[data-we-faq-item]');
        if (!item) return;

        const isOpen = !item.classList.contains('is-open');

        isTransitioning = true;
        trigger.disabled = true;
        setItemOpen(item, isOpen);

        window.setTimeout(() => {
          isTransitioning = false;
          trigger.disabled = false;
        }, prefersReducedMotion() ? 0 : ANIMATION_DELAY);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-we-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const faq = event.target.querySelector('[data-we-faq]');
    if (faq) initFaq(faq);
  });
})();
